import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.Node
import org.w3c.dom.events.Event
import org.w3c.dom.get

@StimulusController(targets = ["button", "checkbox", "all"])
@JsExport
class CheckboxController(context: dynamic) : Controller(context) {
    val checkboxes by checkboxTargets<HTMLInputElement>()
    val allCheckbox by allTarget<HTMLInputElement>()

    @JsName("update")
    fun update() {
        val checked = checkboxes.count { it.checked }

        when (checked) {
            0 -> {
                allCheckbox.checked = false
                allCheckbox.indeterminate = false
            }
            checkboxes.size -> {
                allCheckbox.checked = true
                allCheckbox.indeterminate = false
            }
            else -> allCheckbox.indeterminate = true
        }
    }

    @JsName("toggleAll")
    fun toggleAll(e: Event) {
        checkboxes.forEach {
            it.checked = e.currentTarget.asDynamic().checked
        }
    }

    @JsName("toggle")
    fun toggle(e: Event) {
        console.log(e)
        val target = e.target?.asDynamic().unsafeCast<HTMLElement>()
        if(target.attributes.getNamedItem("data-checkbox-target") != null){
            println("Here")
            return
        }

        val container = target.closest("tr") ?: return
        val checkboxTarget = container.querySelector("[data-checkbox-target=\"checkbox\"]").asDynamic().unsafeCast<HTMLInputElement?>()

        if(checkboxTarget == null) {
            return
        }

        checkboxTarget.checked = !checkboxTarget.checked
        update()
    }
}
